import React, { useContext, useState, useCallback } from "react";
import axios from "axios";
import qs from "qs";
import { AppContext } from "../../../../context/ContextApi";
import { Link, useNavigate, redirect } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import "./style.css";
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import global_variables from "../../../controllers/globalVar.js";
import Loader from "../../../loading/Loading.js";
import { BiSearchAlt } from "react-icons/bi";
import {IoIosArrowBack} from "react-icons/io";
import DateOfBirthInput from '../../../customs/inputs/DateOfBirthInput';

const validationSchema = Yup.object().shape({
  nomFam: Yup.string(),
  prenoms: Yup.string(),
  dateNais: Yup.string(),
});

const SouscripteurInfo = () => {
  const {
    selectedOption,
    setSelectedOption,
    selectedItem,
    setSelectedItem,
    declareAcceuil,
    setDeclareAcceuil,
    successful,
    setSuccessful,
    message,
    setMessage,
    showAlert,
    researchResult,
    setSearchResult,
    alert,
    setUpdateContextStoreData,
  } = useContext(AppContext);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [url, setUrl] = useState("NONE/NONE");
  const navigate = useNavigate();
  const initialValues = {
    nomFam: "",
    prenoms: "",
    dateNais: "",
  };

    const transformDateToYYYYMMDD = (dateString) => {
        const [day, month, year] = dateString.split('/');
        const formattedDate = `${year}${month}${day}`;

        return Number(formattedDate);
    };

  const handleSubmit = useCallback(
    (values) => {
      if (!values.dateNais || !values.nomFam || !values.prenoms) {
        toast.error(
          `Veuillez vérifier les informations saisies, il faut renseigner deux champs obligatoirement.`,
          {
            position: "top-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          }
        );
      } else {
        // let transform = Number(values.dateNais.replace(/-/g, ""));
        let transform = Number(transformDateToYYYYMMDD(values.dateNais));
        var data = qs.stringify({
          nom: `${values.nomFam}`,
          prenom: `${values.prenoms}`,
          date_naissance: `${transform}`,
        });
        var config = {
          method: "post",
          maxBodyLength: Infinity,
          url: `${global_variables().SINISTRE_CARE_WEBSERVICE}/show-subscriber`,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          data: data,
        };
        setLoading(true);

        axios(config)
          .then((response) => {
            if (response.data.status === true && response.data.data.client) {
              toast.success(
                "Votre recherche a bien été effectuée. Nous vous invitons svp à procéder, à présent, à la déclaration du sinistre.",
                {
                  position: "top-center",
                  autoClose: 10000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "dark",
                }
              );

              localStorage.setItem(
                "userLamdaInfo",
                JSON.stringify(response.data.data.client)
              );
              localStorage.setItem(
                "checkbox",
                JSON.stringify(response.data.data.client)
              );
              setUpdateContextStoreData(true);
              navigate("/signup");
            } else if (
              response.data.status === false &&
              response.data.error.includes("web service")
            ) {
              setLoading(false);
              toast.error(`${response.data.error} `, {
                position: "top-center",
                autoClose: 10000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
              });
            } else {
              setLoading(false);
              toast.error(
                `Désolé, votre recherche n’a pas abouti. Nous vous invitons svp à réessayer ou à nous contacter en appelant le 1354.`,
                {
                  position: "top-center",
                  autoClose: 10000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "dark",
                }
              );
            }
          })
          .catch((error) => {
            console.log("error from console,", error);
            setLoading(false);
            toast.error(
              "Désolé, votre recherche n’a pas abouti. Nous vous invitons svp à réessayer ou à nous contacter en appelant le 1354.",
              {
                position: "top-center",
                autoClose: 10000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
              }
            );
            console.log("error from client", error);
          });
      }
    },
    [selectedOption, selectedItem, setSearchResult, researchResult]
  );

  return (
    <Formik
      validationSchema={validationSchema}
      initialValues={initialValues}
      onSubmit={handleSubmit}
    >
      {({ errors, touched }) => (
        <Form>
          <div className="flex info-souscripteur-main">
            <div className="w-1/3 p-2 info-souscripteur-inner-box">
                <label className="block text-center fw-bold leading-3 mb-2" htmlFor="nomFam"> NOM{" "} <strong style={{color: "#cc992d"}}>*</strong></label>
                <Field className="text-center appearance-none border-input inner-box-input font-mono w-full p-2" required
                name="nomFam"
                id="nomFam"
                type="text"
                placeholder="Entrez le nom du client" />
            </div>
            <div className="w-1/3 p-2 info-souscripteur-inner-box">
                <label className="block text-center fw-bold leading-3 mb-2" htmlFor="prenoms">PRENOMS{" "} <strong style={{color: "#cc992d"}}>*</strong></label>
                <Field className="text-center appearance-none border-input inner-box-input font-mono w-full p-2" required
                name="prenoms"
                id="prenoms"
                type="text"
                placeholder="Entrez le(s) prénom(s) du  client" />
            </div>
            <div className="w-1/3 p-2 info-souscripteur-inner-box">
                <label className="block text-center fw-bold leading-3 mb-2" htmlFor="dateNais">DATE DE NAISSANCE{" "} <strong style={{color: "#cc992d"}}>*</strong></label>
                {/*<Field className="text-center appearance-none border-input inner-box-input font-mono w-full p-2" required*/}
                {/*name="dateNais"*/}
                {/*id="dateNais"*/}
                {/*type="date"*/}
                {/*placeholder="Entrez la date de naissance du  client"*/}
                {/*min="1900-01-01"*/}
                {/*max="2030-12-31" />*/}
                <Field
                    name="dateNais"
                    id="dateNais"
                    component={DateOfBirthInput}
                    className="text-center appearance-none border-input inner-box-input font-mono w-full p-2"
                    required
                />
            </div>
          </div>
          {loading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Loader />
            </div>
          ) : (
              <div className="flex justify-center align-center text-center mt-3">
                <Link to="/info" type="button" className="d-flex justify-center items-center btn bts-sm btn-primary mx-2 rounded-pill">
                    <IoIosArrowBack className="mr-2"/> Retour
                </Link>
                <button type="submit"
                  className="d-flex justify-center items-center btn bts-sm btn-warning mx-2 rounded-pill">
                  Rechercher <BiSearchAlt className="ml-2" />
                </button>
              </div>
          )}
        </Form>
      )}
    </Formik>
  );
};

export default SouscripteurInfo;
